import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 're2000',
    ecrans: ['00-2'],
    params: ['rtocleint',
            'demcleint']
});
